import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogUnsubmittedIssues',
  props: {
  amount: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const checkboxVal = ref(false)

const title = t("sfxDialogUnsubmittedIssues.title")
const btnCancel = t("sfxButtons.btn_cancel")
const btnConfirm = t("sfxButtons.btn_confirm")

const bodyDescription = computed(() =>
  props.amount === 1
    ? t("sfxDialogUnsubmittedIssues.body_description", { amount: props.amount }, 1)
    : t("sfxDialogUnsubmittedIssues.body_description", { amount: props.amount }, 2)
)

const labelCheckbox = computed(() =>
  props.amount === 1
    ? t("sfxDialogUnsubmittedIssues.label_checkbox", 1)
    : t("sfxDialogUnsubmittedIssues.label_checkbox", 2)
)

const warningBorder = computed(() => (checkboxVal.value ? "sfx-dialog-border-warning" : ""))

const btnConfirmColor = computed(() => (checkboxVal.value ? "bg-negative" : undefined))

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["q-dialog-plugin", warningBorder.value])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title text-h3 q-pb-xs" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "sfx-message-content" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "text-body1",
                innerHTML: bodyDescription.value
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "row items-center q-mt-xs" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_checkbox, {
                size: "56px",
                class: "sfx-checkbox sfx-checkbox--warning",
                "checked-icon": _unref(Icons).ACCEPT,
                modelValue: checkboxVal.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxVal).value = $event))
              }, null, 8, ["checked-icon", "modelValue"]),
              _createElementVNode("span", {
                class: "q-ml-sm text-body2",
                innerHTML: labelCheckbox.value
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col q-mr-sm",
                onClick: _unref(onDialogCancel),
                label: _unref(btnCancel)
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                class: _normalizeClass(["col", btnConfirmColor.value]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onDialogOK)(checkboxVal.value))),
                label: _unref(btnConfirm)
              }, null, 8, ["class", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 512))
}
}

})